import { ActivityFeedItem } from "types/ActivityFeed";
import { getRequestHeaders } from "utils";
import { handleRes } from "utils";
import { logError } from "utils";

export const getActivityFeedEvents = async (
  tenantID: number | string,
): Promise<ActivityFeedItem[]> => {
  return await fetch(
    `${window.PROPERTY_BASE_URL}/tenant/${tenantID}/activityFeed`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<ActivityFeedItem[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};
